<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  import detalheRateioServico from '~modulos/detalhe-rateio/servico';
  import pessoaServico from '~modulos/acessos/servico';

  export default {
    components: { checkbox },
    props: {
      solicitacao: Object,
      edicao: Boolean,
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        contas: [],
        detalheRateios: [],
        configuracao: this.$storage.configuracao(),
        obrigatorioEndereco: false,
        validarJustificativaAlteracaoLocalEntrega: false,
        mostrarMensagemCuidadoEspecial: false,
        desabilitarEndereco: false,
        carregandoLocalEntrega : false,
      }
    },
    computed: {
      observacaoSolicitacaoContador: function() {
        let quantidadeCaracteres = this.solicitacao.observacaoSolCompras ? 
            this.solicitacao.observacaoSolCompras.length : 0;

        return 500 - quantidadeCaracteres;
      },
      validarLocalEntrega: function() {
        return !!this.solicitacao.alteracaoLocalEntrega ? 'required' : '';
      },
      validarInformacoesFornecedores: function() {
        return this.configuracao.obrigatorioIndicarFornecedores ? 'required' : '';
      },
      validarConta: function() {
        return this.configuracao.selecaoDeContaWeb ? 'required' : '';
      },
      validarDetalheRateio: function() {
        return this.configuracao.utilizarDetalheRateioSolicitacao ? 'required' : '';
      },
      validarJustificativaEntrega: function () {
        return this.validarJustificativaAlteracaoLocalEntrega ? 'required' : '';
      },
    },
    methods: {
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolCompras")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      localEntrega(idProjeto) {
        this.carregandoLocalEntrega = true;

        projetoServico
          .localEntrega(idProjeto)
          .then(localEntrega => {
            this.carregandoLocalEntrega = true;
            this.$set(this.solicitacao, 'cep', localEntrega.cep.trim().length > 3 ? localEntrega.cep : '');
            this.$set(this.solicitacao, 'endereco', localEntrega.endereco);
            this.$set(this.solicitacao, 'bairro', localEntrega.bairro);
            this.$set(this.solicitacao, 'cidade', localEntrega.cidade);
            this.$set(this.solicitacao, 'estado', localEntrega.uf);

            if (!localEntrega.endereco) {
              this.$set(this.solicitacao, 'alteracaoLocalEntrega', true);
              this.obrigatorioEndereco = true;
              this.validarJustificativaAlteracaoLocalEntrega = false;
            }
            else {
              this.$set(this.solicitacao, 'alteracaoLocalEntrega', false);
              this.obrigatorioEndereco = false;
              this.validarJustificativaAlteracaoLocalEntrega = true;
            }

            this.carregandoLocalEntrega = false;
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contas(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeDetalheRateio() {
        detalheRateioServico
          .lista()
          .then(detalheRateios => {
            this.detalheRateios = detalheRateios;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function(e) {
          _this.$set(_this.solicitacao, 'idProjeto', this.value);

          _this.setarProjeto(this.value);

          if (_this.solicitacao.projeto.utilizarMetaEtapaProjeto) {
            _this.$events.emit('carregarMetaEtapas', this.value);
          } else {
            _this.$events.emit('carregarRubricas', this.value);
          }

          if (!this.value) return;
          
          _this.localEntrega(this.value);
          _this.$set(_this.solicitacao, 'idConta', '');
          _this.listaContas(this.value);

          _this.$set(_this.solicitacao, 'alteracaoLocalEntrega', false);
          _this.$set(_this.solicitacao, 'justificativaAltLocalEntrega', '');
        });
      },
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      limparEnderecoEntrega() {
        this.carregandoLocalEntrega = true;
        this.$set(this.solicitacao, 'cep', '');
        this.$set(this.solicitacao, 'endereco', '');
        this.$set(this.solicitacao, 'bairro', '');
        this.$set(this.solicitacao, 'cidade', '');
        this.$set(this.solicitacao, 'estado', '');
        this.$set(this.solicitacao, 'alteracaoLocalEntrega', true);
        this.obrigatorioEndereco = true;
        this.validarJustificativaAlteracaoLocalEntrega = false;
        this.mostrarMensagemCuidadoEspecial = true;
        this.carregandoLocalEntrega = false;
      },
      getCEP() {
        if (this.carregando) return;

        if (this.carregandoLocalEntrega) return;

        if (!this.solicitacao.alteracaoLocalEntrega) return;

        let textoCEP = this.solicitacao.cep.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.endereco = cepObj.logradouro.substring(0, 205);
              this.solicitacao.bairro = cepObj.bairro.substring(0, 60);
              this.solicitacao.cidade = cepObj.localidade.substring(0, 60);
              this.solicitacao.estado = cepObj.uf;
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      }
    },
    mounted() {
      this.$events.on('limparEnderecoEntrega', this.limparEnderecoEntrega);
      this.$events.on('carregarProjetos', this.listaDeProjetos);

      this.iniciarSelect2Projeto();

      if (this.configuracao.utilizarDetalheRateioSolicitacao) {
        this.listaDeDetalheRateio();
      }
    },
    updated(){
        const _this = this;

        this.$watch('solicitacao.cep', function () {
        _this.getCEP();
        })
    },
    watch: {

    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select id="projeto"
                  class="form-control"
                  v-model="solicitacao.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoCompra) || projeto.acompanhamentoPendente || projeto.inativoDebito">
              {{ projeto.nomeProjeto }}
              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoCompra)">
                (Data limite até: {{ projeto.dataLimiteSolicitacaoCompra | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoCompra)  && !projeto.inativoDebito">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>

              <template v-if="projeto.inativoDebito">
                (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input type="text"
                 class="form-control"
                 v-model="solicitacao.projeto.nomeProjeto"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarDetalheRateio, {'has-error': errors.has('detalheRateio')}]">
          <label class="control-label" for="detalhe-rateio">Detalhe rateio</label>

          <select id="detalhe-rateio"
                  class="form-control"
                  v-model="solicitacao.idDetalheRateio"
                  data-vv-name="detalheRateio"
                  data-vv-as="detalhe rateio"
                  v-validate="validarDetalheRateio">
            <option value="">Selecione...</option>
            <option :value="detalheRateio.id" v-for="detalheRateio in detalheRateios">{{ detalheRateio.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('detalheRateio')">{{ errors.first('detalheRateio') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.selecaoDeContaWeb">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarConta, {'has-error': errors.has('conta')}]">
          <label class="control-label" for="id-conta">Conta</label>

          <select id="id-conta"
                  class="form-control"
                  v-model="solicitacao.idConta"
                  data-vv-name="conta"
                  v-validate="validarConta">
            <option value="">{{ contas.length > 0 ? 'Selecione...' : 'Selecione o projeto' }}</option>
            <option :value="conta.id" v-for="conta in contas">{{ conta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>
    </div>

    <div class="alert alert-warning" role="alert" v-if="mostrarMensagemCuidadoEspecial">
      <div class="row">
        <div class="col-xs-12">
          Informar endereço de entrega do projeto/departamento para recebimento. A Fundação não se responsabiliza por armazenamento de itens com cuidados especiais.
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="checkbox">
          <checkbox v-model="solicitacao.alteracaoLocalEntrega" value="1" type="success" :readonly="obrigatorioEndereco">
            Alterar local de entrega (Endereço no qual o item deverá será entregue)
          </checkbox>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('cep'), 'required': solicitacao.alteracaoLocalEntrega}">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="solicitacao.cep"
                 :disabled="!!!solicitacao.alteracaoLocalEntrega || desabilitarEndereco"
                 data-vv-name="cep"
                 v-validate="validarLocalEntrega"
                 v-mascara="'cep'">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="form-group" :class="{'has-error': errors.has('endereco'), 'required': solicitacao.alteracaoLocalEntrega}">
          <label class="control-label" for="endereco">Endereço</label>

          <input type="text"
                 class="form-control"
                 id="endereco"
                 v-model="solicitacao.endereco"
                 :disabled="!!!solicitacao.alteracaoLocalEntrega || desabilitarEndereco"
                 data-vv-as="endereço"
                 data-vv-name="endereco"
                 maxlength="205"
                 v-validate="validarLocalEntrega">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('bairro'), 'required': solicitacao.alteracaoLocalEntrega}">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="solicitacao.bairro"
                 :disabled="!!!solicitacao.alteracaoLocalEntrega || desabilitarEndereco"
                 data-vv-name="bairro"
                 maxlength="60"
                 v-validate="validarLocalEntrega">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('cidade'), 'required': solicitacao.alteracaoLocalEntrega}">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="solicitacao.cidade"
                 :disabled="!!!solicitacao.alteracaoLocalEntrega || desabilitarEndereco"
                 data-vv-name="cidade"
                 maxlength="60"
                 v-validate="validarLocalEntrega">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group" :class="{'has-error': errors.has('estado'), 'required': solicitacao.alteracaoLocalEntrega}">
          <label class="control-label" for="estado">Estado</label>

          <select class="form-control"
                  id="estado"
                  v-model="solicitacao.estado"
                  :disabled="!!!solicitacao.alteracaoLocalEntrega || desabilitarEndereco"
                  data-vv-name="estado"
                  v-validate="validarLocalEntrega">
            <option value="" selected>Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="!!solicitacao.alteracaoLocalEntrega">
      <div class="col-xs-12">
        <div class="form-group" :class="{'has-error': errors.has('justificativa'), 'required': validarJustificativaAlteracaoLocalEntrega}">
          <label class="control-label" for="justificativa">Justificativa de alteração do Local de Entrega</label>

          <textarea class="form-control"
                    id="justificativa"
                    v-model="solicitacao.justificativaAltLocalEntrega"
                    data-vv-as="justificativa de alteração do local de entrega"
                    data-vv-name="justificativa"
                    v-validate="validarJustificativaEntrega">
          </textarea>

          <p class="text-danger" v-show="errors.has('justificativa')">{{ errors.first('justificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarInformacoesFornecedores, {'has-error': errors.has('informacoesFornecedores')}]">
          <label class="control-label" for="informacoes-fornecedores">Informações de fornecedores</label>

          <textarea class="form-control"
                    id="informacoes-fornecedores"
                    v-model="solicitacao.indicacaoFornec"
                    data-vv-as="informações de fornecedores"
                    data-vv-name="informacoesFornecedores"
                    v-validate="validarInformacoesFornecedores">
          </textarea>

          <p class="text-danger" v-show="errors.has('informacoesFornecedores')">{{ errors.first('informacoesFornecedores') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="!configuracao.solCompraOcultarObservacoesCompras">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="observacao-solicitacao">
            Observação da Solicitação/Detalhes ({{ observacaoSolicitacaoContador }})
          </label>

          <textarea class="form-control"
                    id="observacao-solicitacao"
                    v-model="solicitacao.observacaoSolCompras"
                    maxlength="500">
          </textarea>
        </div>
      </div>
    </div>

    <p>
      <b>
        Informe os dados da pessoa que devemos contatar, caso haja dúvidas ao
        processarmos essa solicitação, ou marque o campo abaixo.
      </b>
    </p>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate="`required|emailcomposto`"
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormDadosSolicitacao.vue